import { planFeatures } from './planFeatures';

interface SubscriptionUser {
  plan?: { level?: unknown } | null;
  acc_countryCode?: string;
  user_feature?: { ESignaturePRCTimes?: unknown; ESignatureHKTimes?: unknown } | null;
}

/** 缺少方案不是免費或付費授權；只顯示已知方案，且不改寫共用的權益範本。 */
export function subscriptionPlan(user: SubscriptionUser | null | undefined, lang: string) {
  if (!user?.plan || user.plan.level === undefined) return undefined;
  const level = user.plan.level;
  if (level !== null && (typeof level !== 'number' || !Number.isInteger(level) || level < 0)) return undefined;
  const template = (planFeatures[lang] ?? planFeatures.en)?.[level === null ? 0 : level + 1];
  if (!template) return undefined;
  const quota = user.acc_countryCode === '+86' ? user.user_feature?.ESignaturePRCTimes : user.user_feature?.ESignatureHKTimes;
  const validQuota = (typeof quota === 'number' && Number.isFinite(quota) && quota >= 0)
    || (typeof quota === 'string' && /^\d+$/.test(quota));
  return {
    ...template,
    features: template.features.map(feature => ({
      ...feature,
      times: feature.check ? (validQuota ? String(quota) : '—') : feature.times,
    })),
  };
}
